import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Divider } from 'sdk'
import { Content } from 'sdk/components'

import { NewsSection } from './components/news-section/NewsSection'
import { resolveHomePageCmsContent } from './cms/defaultCmsContent'
import { HomePageLoaderData } from './interfaces'
import { Hero } from './sections/hero/Hero'
import { AccelerationSection } from './sections/acceleration/AccelerationSection'
import { BottomHeroSection } from './sections/bottom-hero/BottomHeroSection'
import { PartnerProgramFeatureSection } from './sections/partner-program/PartnerProgramFeatureSection'
import { SoundcoreSection } from './sections/soundcore/SoundcoreSection'
import { SoundscapeSection } from './sections/soundscape/SoundscapeSection'
import { TechBenefitsSection } from './sections/tech-benefits/TechBenefitsSection'

export const HomePage: React.FC = () => {
  const { newsfeed, cmsContent } = useLoaderData() as HomePageLoaderData
  const resolvedCmsContent = resolveHomePageCmsContent(cmsContent)

  return (
    <>
      <Hero content={resolvedCmsContent.hero} />
      <Content gap={150}>
        <NewsSection items={newsfeed} />
        <AccelerationSection content={resolvedCmsContent.acceleration} />
        <Divider />
        <SoundcoreSection content={resolvedCmsContent.soundcore} />
        <SoundscapeSection content={resolvedCmsContent.soundscape} />
        <Divider />
        <PartnerProgramFeatureSection content={resolvedCmsContent.partnerProgram} />
        <TechBenefitsSection content={resolvedCmsContent.technologyBenefits} />
      </Content>
      <BottomHeroSection
        title={
          <>
            {resolvedCmsContent.bottomHero.titleLine1}
            {resolvedCmsContent.bottomHero.titleLine2 ? (
              <>
                {' '}
                <br /> {resolvedCmsContent.bottomHero.titleLine2}
              </>
            ) : null}
          </>
        }
        description={resolvedCmsContent.bottomHero.description}
        buttonText={resolvedCmsContent.bottomHero.buttonText}
        buttonHref={resolvedCmsContent.bottomHero.buttonUrl}
      />
    </>
  )
}
